module.exports = __webpack_public_path__ + "img/notice_220901_01.065c50f7.jpg";